import { createNavigateToNextOnboardingPageAction } from "@actions/navigateToNextOnboardingPageActionFactory"

const ORDERED_ONBOARDING_ROUTES_V1 = [
  "gender",
  "age",
  "company",
  "tryFirst",
  "unleashLook",
  "firstImpression",
  "tryFirstSub",
  "styleFeeling",
  "hairstyleFrequency",
  "boldLooks",
  "sharePhoto",
  "experimentingLook",
  "doingAmazing",
  "styleSnapshot",
  "readyCommit",
  "confidenceBoost",
  "futureLook",
  "personality",
  "compliment",
  "styleProfile",
  "readyToTransform",
  "photoUsage",
  "subscriptionCount",
  "almostThere",
] as const

const navigateToNextOnboardingPageActionV1 =
  createNavigateToNextOnboardingPageAction(ORDERED_ONBOARDING_ROUTES_V1)

export default navigateToNextOnboardingPageActionV1
